import React from 'react';
import { Typography } from '@mui/material';

function NotFound() {
  return <Typography variant="h4">404 - Not Found</Typography>;
}

export default NotFound;
